var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMenuDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "4zemwpzuka",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#4zemwpzuka)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cw21ede1ob",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cw21ede1ob)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 21c-.75 0-1.492-.184-2.225-.55C3.042 20.083 2.45 19.6 2 19c.433 0 .875-.171 1.325-.513C3.775 18.146 4 17.65 4 17c0-.834.292-1.542.875-2.125A2.893 2.893 0 0 1 7 14c.833 0 1.542.291 2.125.875.583.583.875 1.291.875 2.125 0 1.1-.392 2.041-1.175 2.825C8.042 20.608 7.1 21 6 21zm0-2c.55 0 1.02-.196 1.412-.588C7.804 18.021 8 17.55 8 17a.968.968 0 0 0-.287-.713A.968.968 0 0 0 7 16a.968.968 0 0 0-.713.287A.968.968 0 0 0 6 17c0 .383-.046.733-.138 1.05a4.725 4.725 0 0 1-.362.9c.083.033.167.05.25.05H6zm5.75-4L9 12.25l8.95-8.95a.977.977 0 0 1 .688-.288.93.93 0 0 1 .712.288l1.35 1.35c.2.2.3.433.3.7 0 .266-.1.5-.3.7L11.75 15z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuDesign);
export default __webpack_public_path__ + "static/media/icMenuDesign.6c3f534f370f9b5bbe2aebb248a6fc6e.svg";
export { ForwardRef as ReactComponent };